export module ColourUtils {
    export function hsvToRgba(col: Hsv): Rgba{
        var r = 0, g = 0, b =0, i, f, p, q, t;
        var s = col.s;
        var v = col.v;
        var h = col.h/360;
        //console.log("hsv received:"+h+","+s+","+v);
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch (i % 6) {
            case 0: r = v, g = t, b = p; break;
            case 1: r = q, g = v, b = p; break;
            case 2: r = p, g = v, b = t; break;
            case 3: r = p, g = q, b = v; break;
            case 4: r = t, g = p, b = v; break;
            case 5: r = v, g = p, b = q; break;
        }
        return  {
            r : Math.round(r * 255),
            g : Math.round(g * 255),
            b : Math.round(b * 255),
            a : 1
        };
    }
    export function rgbaToString(col: Rgba): string{
        return 'rgba('+col.r+','+col.g+','+col.b+','+col.a+')';
    } 
    export function hsvToRgbaToStr(col: Hsv): string{
        return rgbaToString(hsvToRgba(col));
    }
    export function rgbaToHex(rgba: Rgba, allow4Char: boolean) {

        var hex = [
            pad2(Math.round(rgba.r).toString(16)),
            pad2(Math.round(rgba.g).toString(16)),
            pad2(Math.round(rgba.b).toString(16)),
            pad2(convertDecimalToHex(rgba.a.toString(16)))
        ];
    
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        }
    
        return hex.join("");
    }
    function pad2(c: any) {
        return c.length == 1 ? '0' + c : '' + c;
    }
    function convertDecimalToHex(d:string) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
}
export interface Hsv{
    h: number, //0 to 359
    s: number, //0 to 1
    v: number //0 to 1
}
export interface Rgba{
    r: number,
    g: number,
    b: number,
    a: number
}